import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
import { useLanguage } from '../contexts/LanguageContext';
export function WasIstSection() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="py-16 lg:py-24 bg-[#0d1225]" data-id="element-287">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-288">
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-289">
          {t('about.title')}
        </h2>

        <p className="text-gray-400 text-lg leading-relaxed mb-8" data-id="element-290">
          {t('about.text1')}
        </p>

        <p className="text-gray-400 text-lg leading-relaxed mb-10" data-id="element-291">
          {t('about.text2')}
        </p>

        <button onClick={openCalendlyPopup} className="inline-flex items-center gap-2 bg-[#ff6b35] hover:bg-[#ff5722] text-white px-8 py-4 rounded-lg font-semibold transition-colors" data-id="element-292">
          {t('about.cta')}
          <ArrowRightIcon className="w-5 h-5" data-id="element-293" />
        </button>
      </div>
    </section>;
}